import { DateTime } from 'luxon';

import { Language } from '@/common/models';
import { ILanguageAPI } from '@/common/models/misc-api-models/Language';
import { toServerDateTimeNoTimezone } from '@/globals';
import rootState from '@/store/state';
import Validatable from '@/validator/Validatable';

export interface IUnitLanguage {
  id: number;
  languageID: number;
  unitID: number;
  unitLanguage?: Language;
  created_on_utc: string;
  modified_on_utc: string;
}

export interface IUnitLanguageAPI {
  unitlanguage_id: number;
  language_id: number;
  unit_id: number;
  language?: ILanguageAPI;
  created_on_utc: string;
  modified_on_utc: string;
}
export default class UnitLanguage extends Validatable {
  languageID: number;
  unitID: number;
  unitLanguage?: Language;
  createdOnUtc: DateTime;
  modifiedOnUtc: DateTime;

  constructor(
    id = -1,
    languageID?: number,
    unitID?: number,
    unitLanguage?: Language,
    createdOnUtc?: DateTime,
    modifiedOnUtc?: DateTime,
  ) {
    super();
    this.id = id;
    this.languageID = languageID;
    this.unitID = unitID;
    this.unitLanguage = unitLanguage;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
  }

  get language(): Language {
    // In case you already have the expanded language, use that
    if (this.unitLanguage) return this.unitLanguage;

    const language = rootState.orgApp.ReferenceData.languages.find((x) => x.id === this.languageID);
    if (language === undefined) {
      return null;
    }
    return language;
  }

  static fromApi(apiObject: IUnitLanguageAPI): UnitLanguage {
    return new UnitLanguage(
      apiObject.unitlanguage_id,
      apiObject.language_id,
      apiObject.unit_id,
      apiObject.language != null ? Language.fromApi(apiObject.language) : null,
      apiObject.created_on_utc ? DateTime.fromISO(apiObject.created_on_utc) : null,
      apiObject.modified_on_utc ? DateTime.fromISO(apiObject.modified_on_utc) : null,
    );
  }

  static fromObject(obj: IUnitLanguage): UnitLanguage {
    return super.fromObject(obj, new UnitLanguage());
  }

  toApi(): IUnitLanguageAPI {
    return {
      unitlanguage_id: this.id >= 0 ? this.id : undefined,
      language_id: this.languageID,
      unit_id: this.unitID,
      created_on_utc: toServerDateTimeNoTimezone(this.createdOnUtc, true),
      modified_on_utc: toServerDateTimeNoTimezone(this.modifiedOnUtc, true),
    };
  }

  static validatorCreateRules(): Record<string, string> {
    return {};
  }
}
